import Utilities from "../dependencies/custom/react-utilities";
import Settings from "../dependencies/custom/settings";

const tableMeta = (valuesStore) => {
  const statuses = valuesStore.getValue("statuses");
  const klasses = valuesStore.getValue("klasses");
  const st_subjects = valuesStore.getValue("subjects");
  const st_streams = valuesStore.getValue("streams");
  const st_acadyrs = valuesStore.getValue("academic_year");
  const st_terms = valuesStore.getValue("term");

  const stats = JSON.stringify(
    Utilities.objectFromArray(statuses, "id", "status"),
  );
  const klass = JSON.stringify(
    Utilities.objectFromArray(klasses, "id", "name"),
  );

  const yesNO = JSON.stringify({ 0: "No", 1: "Yes" });
  const subjects = JSON.stringify(
    Utilities.objectFromArray(st_subjects, "id", "name"),
  );
  const streams = JSON.stringify(
    Utilities.objectFromArray(st_streams, "id", "name"),
  );
  const acadyrs = JSON.stringify(
    Utilities.objectFromArray(st_acadyrs, "id", "acadyr"),
  );
  const terms = JSON.stringify(
    Utilities.objectFromArray(st_terms, "id", "name"),
  );

  return [
    //accommodation
    {
      table_name: "ACCOMMODATION",
      column_name: "name",
      col_real_name: "Name",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ACCOMMODATION",
      column_name: "category",
      col_real_name: "Category",
      type: "jsonSelect",
      options: JSON.stringify({ House: "House", Dormitory: "Dormitory" }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ACCOMMODATION",
      column_name: "capacity",
      col_real_name: "Capacity", //change later to csv|json select
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },
    //classes
    {
      table_name: "KLASSES",
      column_name: "name",
      col_real_name: "Class",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "KLASSES",
      column_name: "classGroup",
      col_real_name: "Group", //change later to csv|json select
      type: "jsonSelect",
      options: JSON.stringify({
        PreSchool: "Preschool",
        "Lower Primary": "Lower Primary",
        "Upper Primary": "Upper Primary",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //STREAMS
    {
      table_name: "STREAMS",
      column_name: "name",
      col_real_name: "Name",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //subjects
    {
      table_name: "SUBJECTS",
      column_name: "subject",
      col_real_name: "Subject",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECTS",
      column_name: "for_interview",
      col_real_name: "For Interview",
      type: "jsonSelect",
      options: JSON.stringify({ 0: "No", 1: "Yes" }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECTS",
      column_name: "subjectType",
      col_real_name: "Type",
      type: "jsonSelect",
      options: JSON.stringify({
        Nursery: "Nursery",
        "Lower Primary": "Lower Primary",
        "Upper Primary": "Upper Primary",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECTS",
      column_name: "subjectCategory",
      col_real_name: "Category",
      type: "jsonSelect",
      options: JSON.stringify({
        Core: "Core",
        Subsidiary: "Subsidiary",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //statuses
    {
      table_name: "STATUSES",
      column_name: "status",
      col_real_name: "Status",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "STATUSES",
      column_name: "lock_form",
      col_real_name: "Lock form",
      type: "jsonSelect",
      options: JSON.stringify({ 0: "No", 1: "Yes" }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "STATUSES",
      column_name: "show_score_btn",
      col_real_name: "Show Score Button",
      type: "jsonSelect",
      options: JSON.stringify({ 0: "No", 1: "Yes" }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //status transitions
    {
      table_name: "STATUS_TRANSITIONS",
      column_name: "klass",
      col_real_name: "Class",
      type: "jsonSelect",
      options: klass,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "STATUS_TRANSITIONS",
      column_name: "current_status",
      col_real_name: "Current Status",
      type: "jsonSelect",
      options: stats,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "STATUS_TRANSITIONS",
      column_name: "can_change_to",
      col_real_name: "Can Change To",
      type: "jsonMultiSelect",
      options: stats,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //NATIONALITY
    {
      table_name: "NATIONALITY",
      column_name: "country",
      col_real_name: "Country",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "NATIONALITY",
      column_name: "nationality",
      col_real_name: "Nationality",
      type: "text",
      options: stats,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //CLASS GROUPS
    // {
    //     table_name: 'CLASS_GROUPS',
    //     column_name: 'group',
    //     col_real_name: 'Group',
    //     type: 'text',
    //     backend_visible: 1,
    //     editable: 1,
    //     validator: 'validateEmptyString',
    //     rank: 1,
    //     disabled: 0
    // },
    //RELATIONSHIP
    {
      table_name: "RELATIONSHIP",
      column_name: "name",
      col_real_name: "Relationship",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "RELATIONSHIP",
      column_name: "block",
      col_real_name: "Blocked",
      type: "jsonSelect",
      options: yesNO,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //ROLES
    {
      table_name: "ROLES",
      column_name: "name",
      col_real_name: "System Name",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROLES",
      column_name: "customName",
      col_real_name: "Real Name",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROLES",
      column_name: "description",
      col_real_name: "Description",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: null,
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROLES",
      column_name: "block",
      col_real_name: "Blocked",
      type: "jsonSelect",
      options: yesNO,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //USER_ROLES
    {
      table_name: "USER_ROLES",
      column_name: "user",
      col_real_name: "User",
      type: "sqlSelect",
      options: JSON.stringify({
        sql: "",
        key: "userID",
        value: "fullName,phone",
        endpoint: Settings.urls.auth.staffList,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USER_ROLES",
      column_name: "roleIds",
      col_real_name: "Roles",
      type: "sqlMultiSelect",
      options: JSON.stringify({
        sql: "",
        key: "id",
        value: "name",
        endpoint: Settings.urls.rbac.roles,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    // {
    //     table_name: 'USER_ROLES',
    //     column_name: 'description',
    //     col_real_name: 'Description',
    //     type: 'text',
    //     backend_visible: 1,
    //     editable: 1,
    //     validator: null,
    //     rank: 1,
    //     disabled: 0
    // },
    {
      table_name: "USER_ROLES",
      column_name: "block",
      col_real_name: "Blocked",
      type: "jsonSelect",
      options: yesNO,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //ROLE_PAGES
    {
      table_name: "ROLE_PAGES",
      column_name: "roleId",
      col_real_name: "Role",
      type: "sqlSelect",
      options: JSON.stringify({
        sql: "",
        key: "id",
        value: "name",
        endpoint: Settings.urls.rbac.roles,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROLE_PAGES",
      column_name: "pageIds",
      col_real_name: "Pages",
      type: "sqlMultiSelect",
      options: JSON.stringify({
        sql: "",
        key: "id",
        value: "customName,route",
        endpoint: Settings.urls.rbac.pages,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    // {
    //     table_name: 'ROLE_PAGES',
    //     column_name: 'description',
    //     col_real_name: 'Description',
    //     type: 'text',
    //     backend_visible: 1,
    //     editable: 1,
    //     validator: null,
    //     rank: 1,
    //     disabled: 0
    // },
    {
      table_name: "ROLE_PAGES",
      column_name: "block",
      col_real_name: "Blocked",
      type: "jsonSelect",
      options: yesNO,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //ROLE_PERMISSIONS
    {
      table_name: "ROLE_PERMISSIONS",
      column_name: "roleId",
      col_real_name: "Role",
      type: "sqlSelect",
      options: JSON.stringify({
        sql: "",
        key: "id",
        value: "name",
        endpoint: Settings.urls.rbac.roles,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROLE_PERMISSIONS",
      column_name: "permissionIds",
      col_real_name: "Permissions",
      type: "sqlMultiSelect",
      options: JSON.stringify({
        sql: "",
        key: "id",
        value: "customName",
        endpoint: Settings.urls.rbac.permissions,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    // {
    //     table_name: 'ROLE_PERMISSIONS',
    //     column_name: 'description',
    //     col_real_name: 'Description',
    //     type: 'text',
    //     backend_visible: 1,
    //     editable: 1,
    //     validator: null,
    //     rank: 1,
    //     disabled: 0
    // },
    {
      table_name: "ROLE_PERMISSIONS",
      column_name: "block",
      col_real_name: "Blocked",
      type: "jsonSelect",
      options: yesNO,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //USERS
    {
      table_name: "USERS",
      column_name: "fullName",
      col_real_name: "Full Name",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "email",
      col_real_name: "Email",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateSimpleEmail",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "staffId",
      col_real_name: "Staff ID",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "countryCode",
      col_real_name: "Country Code",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "phone",
      col_real_name: "Telephone",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "password",
      col_real_name: "Password",
      type: "text",
      backend_visible: 1,
      editable: 1,
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "USERS",
      column_name: "isStaff",
      col_real_name: "Is Admin",
      type: "jsonRadio",
      options: JSON.stringify({ 0: "No", 1: "Yes" }),
      backend_visible: 0,
      editable: 1,
      rank: 1,
      disabled: 0,
    },

    //BUSES
    {
      table_name: "BUSES",
      column_name: "busNumber",
      col_real_name: "Bus Number",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "BUSES",
      column_name: "plateNumber",
      col_real_name: "Registration Number Plate",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "BUSES",
      column_name: "capacity",
      col_real_name: "Capacity",
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "BUSES",
      column_name: "status",
      col_real_name: "Status",
      type: "csvSelect",
      options: "Active,Retired,Maintenance",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //DRIVERS
    {
      table_name: "DRIVERS",
      column_name: "userID",
      col_real_name: `Driver's Name`,
      type: "sqlSelect",
      options: JSON.stringify({
        key: "userID",
        value: "fullName,staffId",
        endpoint: Settings.urls.auth.listdrivers,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "DRIVERS",
      column_name: "licenseNumber",
      col_real_name: "License Number",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "DRIVERS",
      column_name: "licenseExpiry",
      col_real_name: "License Expiry Date",
      type: "date",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "DRIVERS",
      column_name: "status",
      col_real_name: "Status",
      type: "csvSelect",
      options: "Active,Inactive",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //ROUTES
    {
      table_name: "ROUTES",
      column_name: "name",
      col_real_name: "Name of Route",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "ROUTES",
      column_name: "distanceKm",
      col_real_name: "Distance (Km)",
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //PARENT ROUTES SELECTION
    {
      table_name: "PARENT_ROUTES",
      column_name: "routeID",
      col_real_name: "Route",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "name",
        endpoint: Settings.urls.transport.route,
        endpoint_result_key: "data",
      }),
      // extra_options: JSON.stringify({
      //     targets: [
      //         { target: 'busStopID', endpoint: `${Settings.urls.transport.route}/this.value/stops`, endpoint_result_key: 'data', key: 'id', value: 'name,routeName' }
      //     ]
      // }),
      backend_visible: 1,
      editable: 1,
      validator: "",
      rank: 1,
      disabled: 0,
    },

    {
      table_name: "PARENT_ROUTES",
      column_name: "transportTypeID",
      col_real_name: "Preference",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "name",
        endpoint: Settings.urls.transport.transporttype,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //DRIVER BUS ROUTE
    {
      table_name: "DRIVER_BUS_ROUTE",
      column_name: "driverID",
      col_real_name: `Driver's Name`,
      type: "sqlSelect",
      options: JSON.stringify({
        key: "userID",
        value: "fullName,staffId",
        endpoint: Settings.urls.auth.listdrivers,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "DRIVER_BUS_ROUTE",
      column_name: "busID",
      col_real_name: "Bus",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "busNumber,plateNumber",
        endpoint: Settings.urls.transport.buses,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "DRIVER_BUS_ROUTE",
      column_name: "routeID",
      col_real_name: "Route",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "name",
        endpoint: Settings.urls.transport.route,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "",
      rank: 1,
      disabled: 0,
    },

    //FUEL_REQUEST
    {
      table_name: "FUEL_REQUEST",
      column_name: "requestLitres",
      col_real_name: "Litres",
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "FUEL_REQUEST",
      column_name: "purpose",
      col_real_name: "Purpose",
      type: "textArea",
      backend_visible: 1,
      editable: 1,
      validator: "",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "FUEL_REQUEST",
      column_name: "busID",
      col_real_name: "Bus",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "busNumber,plateNumber",
        endpoint: Settings.urls.transport.buses,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "FUEL_REQUEST",
      column_name: "driverID",
      col_real_name: `Driver's Name`,
      type: "sqlSelect",
      options: JSON.stringify({
        key: "userID",
        value: "fullName,staffId",
        endpoint: Settings.urls.auth.listdrivers,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      rank: 1,
      disabled: 0,
    },
    //TRANSPORT TYPES
    {
      table_name: "TRANPORT_TYPES",
      column_name: "name",
      col_real_name: "Type",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //TRANSPORT TARIFFS
    {
      table_name: "TRANPORT_TARIFFS",
      column_name: "routeID",
      col_real_name: "Route",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "name",
        endpoint: Settings.urls.transport.route,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "TRANPORT_TARIFFS",
      column_name: "transportTypeID",
      col_real_name: "Preference",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "name",
        endpoint: Settings.urls.transport.transporttype,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "TRANPORT_TARIFFS",
      column_name: "tariff",
      col_real_name: "Fare",
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },

    //MAINTENANCE REQUESTS
    {
      table_name: "MAINTENANCE_REQUEST",
      column_name: "maintenanceType",
      col_real_name: "Type",
      type: "csvSelect",
      options: "Scheduled,Unscheduled,Emergency,Preventive",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "MAINTENANCE_REQUEST",
      column_name: "busID",
      col_real_name: "Bus/Car",
      type: "sqlSelect",
      options: JSON.stringify({
        key: "id",
        value: "busNumber,plateNumber",
        endpoint: Settings.urls.transport.buses,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "MAINTENANCE_REQUEST",
      column_name: "issue",
      col_real_name: "Title",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "MAINTENANCE_REQUEST",
      column_name: "description",
      col_real_name: "Description",
      type: "textArea",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "MAINTENANCE_REQUEST",
      column_name: "estimatedCost",
      col_real_name: "Cost",
      type: "number",
      backend_visible: 1,
      editable: 1,
      validator: "validateNumber",
      rank: 1,
      disabled: 0,
    },

    //SUBJECT_ASSIGNMENTS
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "teacherID",
      col_real_name: "Teacher",
      type: "sqlSelect",
      options: JSON.stringify({
        sql: "",
        key: "userID",
        value: "fullName,phone",
        endpoint: Settings.urls.auth.staffList,
        endpoint_result_key: "data",
      }),
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "classID",
      col_real_name: "Class",
      type: "jsonMultiSelect",
      options: klass,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "subjectID",
      col_real_name: "Subjects",
      type: "jsonMultiSelect",
      options: subjects,
      backend_visible: 1,
      editable: 1,
      validator: "",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "streamID",
      col_real_name: "Streams",
      type: "jsonMultiSelect",
      options: streams,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "acadyrID",
      col_real_name: "Academic Year",
      type: "jsonSelect",
      options: acadyrs,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "SUBJECT_ASSIGNMENTS",
      column_name: "termID",
      col_real_name: "Term",
      type: "jsonSelect",
      options: terms,
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //PRESCHOOL_LEARNING_AREAS
    {
      table_name: "PRESCHOOL_LEARNING_AREAS",
      column_name: "columnName",
      col_real_name: "Area",
      type: "textArea",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },

    //PRESCHOOL_GRADES
    {
      table_name: "PRESCHOOL_GRADES",
      column_name: "letterGrade",
      col_real_name: "Grade",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    {
      table_name: "PRESCHOOL_GRADES",
      column_name: "remark",
      col_real_name: "Remark",
      type: "text",
      backend_visible: 1,
      editable: 1,
      validator: "validateEmptyString",
      rank: 1,
      disabled: 0,
    },
    //ATTENDANCE REMARKS
    {
      table_name: "ATTENDANCE_REMARKS",
      column_name: "remark",
      col_real_name: "Remark",
      type: "textArea",
      backend_visible: 1,
      editable: 1,
      validator: null,
      rank: 1,
      disabled: 0,
    },
  ];
};

export default tableMeta;
